import { ERouterNames, TFormBuilderContent } from '@/types';

type TFormBuilderHeaderConfigRedirect = {
  main: string;
  mode: string;
};

type TFormBuilderHeaderConfigMode = Record<
  'edit' | 'preview',
  {
    redirect: TFormBuilderHeaderConfigRedirect;
  }
>;

type TFormBuilderHeaderConfigValues = TFormBuilderHeaderConfigMode & {
  headerModalTemplate: {
    new: string;
    edit: string;
  };
  showSignature: boolean;
};

export const formBuilderHeaderConfig: Record<
  TFormBuilderContent,
  TFormBuilderHeaderConfigValues
> = {
  formBuilder: {
    showSignature: true,
    headerModalTemplate: {
      new: 'form-builder.new-template',
      edit: 'form-builder.edit-template',
    },
    edit: {
      redirect: {
        main: ERouterNames.DOCUMENT_MANAGEMENT,
        mode: `${ERouterNames.DOCUMENT_MANAGEMENT}/${ERouterNames.FORM_BUILDER_PREVIEW}`,
      },
    },
    preview: {
      redirect: {
        main: ERouterNames.DOCUMENT_MANAGEMENT,
        mode: `${ERouterNames.DOCUMENT_MANAGEMENT}/${ERouterNames.FORM_BUILDER}`,
      },
    },
  },
  visitNote: {
    showSignature: true,
    headerModalTemplate: {
      new: 'form-builder.new-visit-note-template',
      edit: 'form-builder.edit-template-name',
    },
    edit: {
      redirect: {
        main: ERouterNames.VISIT_NOTES_TEMPLATES,
        mode: ERouterNames.VISIT_NOTE_TEMPLATE_PREVIEW,
      },
    },
    preview: {
      redirect: {
        main: ERouterNames.VISIT_NOTES_TEMPLATES,
        mode: ERouterNames.VISIT_NOTE_TEMPLATE_EDIT,
      },
    },
  },
};
